import React from 'react'
import { withTranslation } from 'react-i18next'
import i18next from 'i18next'

import './LetsTalk.scss'

const LetsTalk = ({ title, style = {}, t }) => {
    const lang = i18next.language

    return (
        <div style={style} className="lets-talk">
            <p className="lets-talk__header">{title}</p>
            <div className="lets-talk__btn">
                <a style={lang === 'ru-RU' ? { fontSize: '14px' } : {}} href="/contacts">
                    {t('_common.lets_talk')}
                </a>
            </div>
        </div>
    )
}

export default withTranslation('translations')(LetsTalk)
